var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.512 13.15l2.948 2.948c1.354 1.355 2.428 2.962 3.161 4.732.733 1.77 1.11 3.666 1.11 5.58 0 1.916-.377 3.813-1.11 5.582-.733 1.77-1.807 3.377-3.161 4.731l-.738.736c-2.735 2.735-6.444 4.271-10.312 4.271-3.868 0-7.578-1.536-10.313-4.271C2.362 34.724.826 31.014.826 27.146c0-3.868 1.536-7.577 4.271-10.312l2.948 2.948c-.974.965-1.748 2.114-2.277 3.38-.53 1.265-.803 2.623-.806 3.995-.003 1.372.265 2.73.788 3.998.524 1.268 1.293 2.42 2.263 3.39.97.97 2.122 1.74 3.39 2.263 1.268.523 2.627.791 3.998.788 1.372-.003 2.73-.277 3.995-.806 1.266-.529 2.415-1.303 3.38-2.277l.738-.738c1.953-1.953 3.05-4.602 3.05-7.364 0-2.762-1.097-5.411-3.05-7.365l-2.948-2.948 2.948-2.945-.002-.003zm13.996 12.523l-2.946-2.945c.974-.966 1.748-2.115 2.277-3.38.53-1.266.803-2.624.806-3.996.003-1.371-.265-2.73-.788-3.998-.524-1.268-1.293-2.42-2.263-3.39-.97-.97-2.122-1.739-3.39-2.262-1.268-.524-2.627-.792-3.998-.789-1.372.003-2.73.277-3.995.806-1.266.53-2.415 1.303-3.38 2.277l-.738.738c-1.953 1.953-3.05 4.602-3.05 7.364 0 2.762 1.097 5.412 3.05 7.365l2.948 2.948-2.948 2.946-2.946-2.946c-1.354-1.354-2.428-2.962-3.161-4.732-.733-1.769-1.11-3.665-1.11-5.58 0-1.916.377-3.812 1.11-5.582.733-1.77 1.807-3.377 3.161-4.731l.738-.736C19.62 2.315 23.329.78 27.197.78c3.868 0 7.578 1.536 10.313 4.271 2.735 2.735 4.271 6.445 4.271 10.313 0 3.868-1.536 7.577-4.271 10.312l-.002-.002z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.587094077cb49fcef9c6c16d174dc4c7.svg";
export { ForwardRef as ReactComponent };